import React from 'react';
import MapIcon from '../../../assets/img/icons/ic-location-gray.svg';
import styles from './PropertyDetailsTitle.module.scss';

function PropertyDetailsTitle({ propertyData, children }) {
  return (
    <div className={`${styles.titleWrapper} t-600`}>
      <div className="flex flex-v-center">
        <h1 className={`${styles.title} t-700 text-truncate`}>
          {propertyData.title ? propertyData.title : null}
        </h1>
        {children}
      </div>
      {propertyData && propertyData.location ? (
        <div className={`${styles.subtitle} flex flex-v-center`}>
          <MapIcon />
          <span className="t-500">
            {propertyData?.location?.locationName}
          </span>
        </div>
      ) : null}
    </div>
  );
}

export default PropertyDetailsTitle;
